<template>
  <div id="app">

      <router-view id="page" class="page" />

  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  computed: {
    layout() {
      return this.$route.meta.layout || "default-layout";
    },
  },
  mounted() {

  },
};
</script>

<style lang="scss">
@import "./assets/global.scss";
.page {
  min-height: calc(100vh - 56px);
}
</style>
